module.exports = __webpack_public_path__ + "img/SKIN.42cd6c92.svg";